import {RouteRecordRaw} from "vue-router";

export default <Array<RouteRecordRaw>>[
    {
        path: '',
        meta: {auth: true},
        component: () => import( /* webpackChunkName: "activity_tab_main" */ './ActivityTabMainPage.vue'),
    },
    {
        path: 'employee',
        meta: {auth: true},
        component: () => import(  /* webpackChunkName: "activity_tab_employee" */ './ActivityTabEmployeePage.vue'),
    }
]